module.exports = __webpack_public_path__ + "static/img/demo_3_and.b25662a2.png";